import { render } from "./boxInsertionTeaser.vue?vue&type=template&id=683f0c2e"
import script from "./boxInsertionTeaser.vue?vue&type=script&lang=js"
export * from "./boxInsertionTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__